import { ProductType } from 'src/common/interfaces/Tenant';
import { useConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';
import { useUserTenant } from 'src/common/providers/userTenantProvider/UserTenantProvider';
import { getProductDashboardAccessPermission } from 'src/common/services/CommonDashboardService';

export const usePermissions = (productType: ProductType): boolean => {
	const { tenant } = useUserTenant();
	const context = useConfiguration();
	if (!context?.getToggle) {
		throw new Error('usePermissions must be used within ConfigurationProvider');
	}
	return getProductDashboardAccessPermission(tenant, context.getToggle, productType);
};
